import { Row ,Container, Col } from "react-bootstrap";
import classes from "./Packages.module.scss"
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import RemoveIcon from '@mui/icons-material/Remove';
import { ClientTypes, CustomerRelations } from "../../../store/orgId_context";

const Package = ({packageKey, onClick, packageTitle, active, children, icon, onActivateClick, price, pricePerYear, packageType, packageMainTitle, payType="Monthly", saved}) =>{
    const cirbledBIcon = <FormatBoldIcon style={{backgroundColor:"#2196f3", borderRadius:"50%"}}/>
    let _packageType = packageType || "basic";
    let _packageMainTitle = packageMainTitle || "BASIC";

    return (
        <>
        {/*<Container className={`${classes["relationContainer"]} d-flex flex-column`} style={{height:"100%"}} active={active} onClick={() => onActivateClick(packageKey)}>
            <Row className={classes["titleRow"]}>
                <Col className="col-md-2 align-middle" style={{paddingTop:"0.5rem"}}>{icon}</Col>
                <Col className="col-md-8" style={{textAlign:"center"}}>
                    <div className={classes["titleBadge"]}>{packageTitle}</div>
                </Col>
                <Col className="col-md-2" style={{paddingLeft:"0px"}}>
                    {active==="true" &&  <DoneAllIcon style={{color:"#15d715"}}/>}
                </Col>
            </Row>
            <Row style={{padding:"0.5rem"}}>
                {children}
            </Row>
            <Row className={`${classes["bottomRow"]} mt-auto`} style={{fontSize:"1.5rem", textAlign:"right", padding:"1rem"}}>
                <span>{price}</span>
            </Row>
        </Container>*/}
        <div className={`${classes["pricing-table-3"]} ${classes[_packageType]}`} onClick={onClick} style={active ? {backgroundColor:"#047f04", color:"white"}: {}}>
            <div className={classes["pricing-table-header"]}>
                <h4><strong>{_packageMainTitle}</strong></h4>
                <p>{packageTitle}</p>
            </div>
            {/* <div className={classes["price"]}><strong>{price}</strong> / MONTH</div> */}
            <div className={classes["price"]}><strong>{price}€</strong>
            <br/><span style={{fontSize:"0.8rem", margin:"1rem"}}>{saved && <>-{saved}€</>}</span>
            </div>
            <div className={classes["pricing-body"]}>
                {children}
                {/*<ul className={classes["pricing-table-ul"]}>
                    <li><i className="fa fa-send"></i> Unlimited Email Addresses</li>
                    <li><i className="fa fa-cloud"></i> 50 GB Disk Space</li>
                    <li><i className="fa fa-database"></i> Unlimited MySQL Database</li>
                    <li className="not-avail"><i className="fa fa-clock-o"></i> 24X7 Support</li>
                    <li className="not-avail"><i className="fa fa-envelope"></i> Email Support</li>
                    </ul><a href="#" className="view-more">View More</a>*/}
            </div>
        </div>
        </>
    )
}

export default Package;